import { render, staticRenderFns } from "./BaseFormFile.vue?vue&type=template&id=82ffe192&"
import script from "./BaseFormFile.vue?vue&type=script&lang=js&"
export * from "./BaseFormFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports